"use client";

import React from "react";
import { FormattedDate } from "modules/common/components/ui/FormattedDate";
import { useCardGridItemContext } from "./CardGridItemContext";

export function CardGridItemFormattedDate() {
  const { item } = useCardGridItemContext();

  return <FormattedDate date={`${item.updatedAt}`} />;
}
